import React, { FC } from 'react';

import { FormikImageInputProps } from './FormikImageInput.props';

import FormikImageInputView from './FormikImageInput.view';

const FormikImageInputContainer: FC<FormikImageInputProps> = ({
  name,
  label,
  siteId,
  groupId,
  isDisabled,
  aspectRatio,
  containerProps = {},
  isPartnerPortal = false,
  labelProps = {},
}) => {
  return (
    <FormikImageInputView
      name={name}
      label={label}
      siteId={siteId}
      groupId={groupId}
      labelProps={labelProps}
      isDisabled={isDisabled}
      aspectRatio={aspectRatio}
      containerProps={containerProps}
      isPartnerPortal={isPartnerPortal}
    />
  );
};

export default FormikImageInputContainer;
